import React, { useState, useEffect } from "react"
import mobileUploadStyles from "./MobileUploadPrescription.module.css"
import MobilePrescriptionIcon from "../../../../Assets/svg/mobile-prescription.svg"

const MobileUploadPrescription = () => {

  const handlePrescriptionClick = () => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const token = userDetails && userDetails?.token;
      if (token) {
        // router.push('/uploadprescription')
        window.location.href = process.env.RAZZLE_APP_BASE_URL + "/uploadprescription";
      } else {
        window.location.href = process.env.RAZZLE_APP_BASE_URL;
        // dispatch(setloginSliderstate(true));
      }
    }
    catch {
      window.location.href = process.env.RAZZLE_APP_BASE_URL + "/uploadprescription";
      // console.log("Error")
    }
  };

  return (
    <div className={mobileUploadStyles.uploadPrescriptionDiv}>
      {/* <Image
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/38d924c4-0719-48aa-86cb-14c328bd9236.svg"
          width="38px"
        /> */}
      <img src={MobilePrescriptionIcon} className={mobileUploadStyles.prescriptionIcon} />
      <div className={mobileUploadStyles.detailsFlex}>
        <span className={mobileUploadStyles.uploadPresTxt}>
          Upload Prescription
        </span>
        <span className={mobileUploadStyles.uploadPresTxtSub}>choose from 3500+ health test</span>
      </div>
      <span
        className={mobileUploadStyles.uploadButton}
        onClick={handlePrescriptionClick}
      >
        Upload
      </span>
    </div>
  )
}

export default MobileUploadPrescription;
